import React from "react";
import AdminStatCard from "./AdminStatCard";
import { PHARMACY_HALO_COLORS } from "@/config/colors";

const AdminHaloStatCard = (props) => (
  <AdminStatCard
    gradientFrom={PHARMACY_HALO_COLORS.YELLOW}
    gradientTo="#ffe08a"
    borderColor={PHARMACY_HALO_COLORS.BLUE}
    titleColor={PHARMACY_HALO_COLORS.BLUE}
    valueColor={PHARMACY_HALO_COLORS.BLUE}
    iconGhostColor="#FFFDE7"
    {...props}
  />
);

export default AdminHaloStatCard;
